import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=a3a22a70&"
import script from "./FeaturesList.vue?vue&type=script&lang=js&"
export * from "./FeaturesList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports